import React from 'react';
import { Box } from '@mui/material';
import EditableFolderKebabMenu from '../../Room/components/Edit/EditableFolderKebabMenu';
import { RenameFolderDialog } from '../../Folder/RenameFolderDialog';
import { DeleteFolderDialog } from '../../Folder/DeleteFolderDialog';

interface FolderTileWrapperProps {
  children: React.ReactNode;
  displayName: string;
  isEditMode: boolean;
  isRenameDialogOpen: boolean;
  isDeleteDialogOpen: boolean;
  isDeleting: boolean;
  onRenameClick: () => void;
  onRenameClose: () => void;
  onRenameSuccess: (newName: string) => void;
  onDeleteClick: () => void;
  onDeleteClose: () => void;
  onDeleteConfirm: () => void;
}

const FolderTileWrapper: React.FC<FolderTileWrapperProps> = ({
  children,
  displayName,
  isEditMode,
  isRenameDialogOpen,
  isDeleteDialogOpen,
  isDeleting,
  onRenameClick,
  onRenameClose,
  onRenameSuccess,
  onDeleteClick,
  onDeleteClose,
  onDeleteConfirm,
}) => (
  <>
    <Box position="relative" className="folder-card">
      {children}
      {isEditMode && (
        <Box
          position="absolute"
          top={0}
          right={0}
          display="flex"
          justifyContent="flex-end"
          p={1}
        >
          <EditableFolderKebabMenu
            iconButtonSize="small"
            onRename={onRenameClick}
            onDelete={onDeleteClick}
          />
        </Box>
      )}
    </Box>

    <RenameFolderDialog
      open={isRenameDialogOpen}
      onClose={onRenameClose}
      currentName={displayName}
      onSuccess={onRenameSuccess}
    />

    <DeleteFolderDialog
      open={isDeleteDialogOpen}
      onClose={onDeleteClose}
      onConfirm={onDeleteConfirm}
      loading={isDeleting}
    />
  </>
);

export default React.memo(FolderTileWrapper);
